import React from "react";
import { Form } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import {
  VENDOR_TAGLINE_HINT,
  VENDOR_TAGLINE_LABEL,
  VENDOR_TAGLINE_MAX_LENGTH,
  VENDOR_TAGLINE_PLACEHOLDER,
  vendorTaglineCount,
} from "../utilities/vendorTagline";

/**
 * The tagline input, for every vendor profile and admin vendor editor.
 * Two renderers because the dashboard forms use two UI kits; the label, the
 * hint, the placeholder and the limit come from utilities/vendorTagline.js,
 * so every form says the same thing and stops at the same length.
 *
 * Both pass the change event straight to the form's own handler, with
 * name="tagline", so a form's generic handleChange works unchanged.
 */

/* react-bootstrap forms. Each form passes its own class names and styles so
   the field matches the fields around it. */
export const VendorTaglineControl = ({
  value,
  onChange,
  disabled = false,
  size,
  id = "tagline",
  groupClassName,
  groupStyle,
  labelClassName,
  labelStyle,
  labelIcon = null,
  controlClassName,
  controlStyle,
}) => {
  const text = value || "";
  return (
    <Form.Group className={groupClassName} style={groupStyle}>
      <Form.Label htmlFor={id} className={labelClassName} style={labelStyle}>
        {labelIcon}
        {VENDOR_TAGLINE_LABEL}
      </Form.Label>
      <Form.Control
        id={id}
        name="tagline"
        type="text"
        size={size}
        className={controlClassName}
        style={controlStyle}
        value={text}
        onChange={onChange}
        maxLength={VENDOR_TAGLINE_MAX_LENGTH}
        placeholder={VENDOR_TAGLINE_PLACEHOLDER}
        disabled={disabled}
      />
      <Form.Text muted>
        {VENDOR_TAGLINE_HINT} {vendorTaglineCount(text)}
      </Form.Text>
    </Form.Group>
  );
};

/* Material UI forms (the restaurant Business profile). */
export const VendorTaglineTextField = ({
  value,
  onChange,
  disabled = false,
  className,
}) => {
  const text = value || "";
  return (
    <TextField
      fullWidth
      label={VENDOR_TAGLINE_LABEL}
      name="tagline"
      value={text}
      onChange={onChange}
      disabled={disabled}
      variant="outlined"
      size="small"
      placeholder={VENDOR_TAGLINE_PLACEHOLDER}
      inputProps={{ maxLength: VENDOR_TAGLINE_MAX_LENGTH }}
      helperText={`${VENDOR_TAGLINE_HINT} ${vendorTaglineCount(text)}`}
      className={className}
      InputLabelProps={{ shrink: true }}
    />
  );
};
